import React, { useState, useEffect } from 'react';
import { Button, Input, message, Upload } from 'antd';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseDatePicker from '../../../components/datepicker/base_datepicker';
import BaseDateTimePicker from '../../../components/datepicker/base_datetimePicker';
import BaseColumnSelect from '../../../components/select/base_column_select';
import { restApi, getFileHost, getFileUploadToken } from '../../../apis';
import dayjs from 'dayjs';
const { TextArea } = Input;

const CenterPofileDetail = (props) => {
  const {
    centerId,
    setCenterName,
    setLoading,
    loading,
    data,
    setData,
    isRead,
    setRead,
    optPlans,
    ...rest
  } = props;
  const [messageApi, contextHolder] = message.useMessage();

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      messageApi.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };

  const handleChange = (info) => {
    const { status } = info.file;

    /*
    // log
    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    */
    if (status == 'uploading') {
      if (loading == false) {
        setLoading(true);
      }
    }
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      // console.log('-[file]--->', info.file);
      const payload = info?.file?.response?.payload;
      if (payload) {
        setData &&
          setData((prev) => {
            return {
              ...prev,
              photo_key: payload?.files[0].id,
              photo_path: payload?.files[0].path,
              photo_ext: payload?.files[0].ext,
            };
          });
      }

      setLoading(false);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
      setLoading(false);
    }
  };

  return (
    <div style={{ ...styles.container }}>
      {/* ---------------------------------------------------------------------------------------------------- */}
      {contextHolder}
      <div
        style={{
          ...styles.row,
          padding: '4rem 1rem 4rem 1rem',
          borderBottom: '1px solid #DBDADE',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            ...styles.column,
            flex: undefined,
            width: 136,
            height: 136,
            marginLeft: '1rem', // '2.4rem','1.4rem',
            marginRight: '0.9rem',
            alignItems: 'center',
            justifyContent: 'center',
            // border: '1px solid #DBDADE',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${require('../../../assets/images/bkg_profile.png')})`,
          }}
        >
          <Upload
            name="avatar"
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            //---------------------------------------------
            action={getFileHost()}
            headers={{
              Authorization: `Bearer ${getFileUploadToken()}`,
            }}
            method="post"
            //Content-Disposition: form-data; name="Filedata"; filename="undefined"
            // name="filedata" /// <=== 파일 데이터 저장할 이름
            //---------------------------------------------
          >
            {data?.photo_path ? (
              <img
                width={136}
                height={136}
                // src={`url(${require('../../../assets/images/sample_profile.png')})`}
                // src={require('../../../assets/images/sample_profile.png')}
                src={`https://cdn.humanb.kr/${data.photo_path}/${data.photo_key}.${data.photo_ext}`}
                alt={`no image`}
              />
            ) : (
              <div style={{ marginTop: 8 }}>{`프로필 등록`}</div>
            )}
          </Upload>
        </div>

        <div style={{ ...styles.column }}>
          <BaseColumnInput
            label={`센터장 성명`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    account_name: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.account_name}
          />
          <BaseColumnInput
            label={`센터 전화번호`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_phone: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.center_phone}
          />
        </div>
        <div style={{ ...styles.column }}>
          <BaseColumnInput
            label={`이메일`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    account_email: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data.account_email}
          />
          <BaseColumnInput
            label={`개인 전화번호`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    account_phone: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.account_phone}
          />
        </div>
        <div style={{ ...styles.column }}>
          <BaseColumnInput
            label={`센터명`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_name: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data.center_name}
          />
          <BaseColumnInput
            label={`센터 고유 코드`}
            readonly={isRead}
            disabled
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_identifyCode: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.center_identifyCode}
          />
        </div>
        <div style={{ ...styles.column }}>
        <BaseColumnInput
            label={`변경할 비밀번호`}
            readonly={isRead}
            onChange={(e) => {
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_password: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.center_password}
          />
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div
        style={{
          ...styles.row,
          padding: '3rem 1rem 3rem 1rem',
          borderBottom: '1px solid #DBDADE',
        }}
      >
        <div style={{ ...styles.column }}>
          <BaseDatePicker
            label={`센터 계정 가입일`}
            readonly={isRead}
            onSelectedDate={(e) => {
              // console.log('e===>', e);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_createdAt: e,
                  };
                });
            }}
            width={'32rem'}
            value={data?.center_createdAt}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseColumnInput
            label={`구독 플랜(프로모션) 가격`}
            readonly={isRead}
            onChange={(e) => {
              // console.log('---->', e.target.value);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    contract_paymentAmount: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.contract_paymentAmount}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseColumnSelect
            label={`구독 플랜(프로모션) 결제 방법`}
            readonly={isRead}
            options={[
              {
                value: `가상계좌`,
                label: '가상계좌',
              },
              {
                value: `creditCard`,
                label: `신용/체크카드`,
              },
              {
                value: `실시간 계좌이체`,
                label: `실시간 계좌이체`,
              },
              {
                value: `구독한 플랜(프로모션) 없음`,
                label: `구독한 플랜(프로모션) 없음`,
              },
            ]}
            onChange={(selectedValue) => {
              // console.log(`Selected: ${selectedValue}`);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    contract_paymentMethod: selectedValue,
                  };
                });
            }}
            width={'32rem'}
            value={data?.contract_paymentMethod}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseDatePicker
            label={`구독 플랜(프로모션) 결제 일시`}
            readonly={isRead}
            onSelectedDate={(e) => {
              // console.log('---->', e);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    contract_paidDate: e,
                  };
                });
            }}
            width={'32rem'}
            value={data?.contract_paidDate}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseDateTimePicker
            label={`구독 플랜(프로모션) 시작 일시`}
            readonly={isRead}
            onSelectedDate={(e) => {
              // console.log('---->', e);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    contract_startDate: e,
                  };
                });
            }}
            width={'32rem'}
            value={data?.contract_startDate}
          />
        </div>
        {/* **************************************************** */}
        <div style={{ ...styles.column }}>
          <BaseColumnSelect
            label={`구독 플랜(프로모션)`}
            readonly={isRead}
            options={[...optPlans]}
            onChange={(selectedValue) => {
              // console.log(`Selected: ${selectedValue}`);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    plan_id: selectedValue,
                  };
                });
            }}
            width={'32rem'}
            value={data?.plan_id}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseColumnSelect
            label={`구독 플랜(프로모션) 결제 방식`}
            readonly={isRead}
            options={[
              {
                value: `수동 연결제`,
                label: `수동 연결제`,
              },
              {
                value: `자동 연결제`,
                label: '자동 연결제',
              },
              {
                value: `수동 월결제`,
                label: '수동 월결제',
              },
              {
                value: `자동 월결제`,
                label: '자동 월결제',
              },
              {
                value: `구독한 플랜(프로모션) 없음`,
                label: `구독한 플랜(프로모션) 없음`,
              },
            ]}
            onChange={(selectedValue) => {
              console.log(`Selected: ${selectedValue}`);
            }}
            width={'32rem'}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseColumnInput
            label={`구독 플랜(프로모션) 결제 정보(계좌 or 카드번호)`}
            readonly={isRead}
            onChange={(e) => {}}
            width={'32rem'}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseColumnInput
            label={`등록(설정) IP`}
            readonly={isRead}
            onChange={(e) => {
              // console.log('---->', e.target.value);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    center_ipAddress: e.target.value,
                  };
                });
            }}
            width={'32rem'}
            value={data?.center_ipAddress}
          />
          <div style={{ marginTop: '1rem' }} />
          <BaseDateTimePicker
            label={`구독 플랜(프로모션) 종료 일시`}
            readonly={isRead}
            onSelectedDate={(e) => {
              // console.log('---->', e);
              setData &&
                setData((prev) => {
                  return {
                    ...prev,
                    contract_endDate: e,
                  };
                });
            }}
            width={'32rem'}
            value={data?.contract_endDate}
          />
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div
        style={{
          width: '100%',
          background: '#FFFFFF',
          padding: '2.4rem 2.4rem 2.4rem 2.4rem',
        }}
      >
        <div style={{ ...styles.col_title }}>{`기타 참고 사항`}</div>
        <TextArea
          showCount
          // maxLength={100}
          style={{ height: '25rem', width: '100%', resize: 'none' }}
          onChange={(e) => {
            // console.log('---->', e.target.value);
            setData &&
              setData((prev) => {
                return {
                  ...prev,
                  center_comment: `${e.target.value}`,
                };
              });
          }}
          value={data?.center_comment}
          // value={data.center_comment}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: '#FFF',
    boxShadow: '0px 4px 18px rgba(75, 70, 92, 0.1)',
    borderRadius: 6,
    padding: 0,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    /*
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
		*/
  },

  header: {
    display: 'flex',
    width: '100%',
    height: '6.8rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #DBDADE',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  title: {
    display: 'flex',
    width: '50rem',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    // letterSpacing: 1,
    // textTransform: 'uppercase',
  },
  col_title: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    //font
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  botton_update: {
    display: 'flex',
    width: '14.3rem',
    height: '3.8rem',
    alignItems: 'center',
    justifyContent: 'center',

    border: 0,
    background: `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`,
    // ...item.style,
    color: '#FFF',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    // height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 0.9rem 0rem 0.9rem',
    background: '#FFFFFF',
  },
};
export default CenterPofileDetail;
